import Vue from 'vue';
import router from './routes';
import App from './components/App';

import DataTable from 'laravel-vue-datatable';
Vue.use(DataTable);
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';

Vue.use(Tooltip);
const app = new Vue({
    el: '#app',
    components: {
        App
    },
    router
});
